import { BoxProps, CheckboxGroup as ChakraCheckboxGroup, Flex } from '@chakra-ui/react'
import { startCase } from 'lodash-es'
import { ReactNode, useEffect, useState } from 'react'
import { CheckBox, TextProps } from '.'

interface CheckBoxValue {
  value: string
  label?: string | ReactNode
  checked: boolean
}

export interface Props extends Omit<BoxProps, 'onClick' | 'onChange'> {
  values: CheckBoxValue[]
  onChange: (values: string[]) => void
  textProps?: TextProps
  colorScheme?: string
}

export default function CheckBoxGroup({ values, onChange, textProps, colorScheme }: Props) {
  const [selectedValues, setSelectedValues] = useState<string[]>(
    values.filter(v => v.checked).map(v => v.value)
  )

  useEffect(() => {
    onChange(selectedValues)
  }, [selectedValues])

  function handleToggle(value: string) {
    setSelectedValues(prev =>
      prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]
    )
  }
  return (
    <ChakraCheckboxGroup colorPalette={colorScheme}>
      <Flex direction="column" gap={3}>
        {values.map(({ label, value }) => (
          <CheckBox
            key={value}
            checked={selectedValues.includes(value)}
            children={label || startCase(value)}
            labelProps={textProps}
            onChange={() => handleToggle(value)}
          />
        ))}
      </Flex>
    </ChakraCheckboxGroup>
  )
}
